/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WawiOrdersView } from '../models/WawiOrdersView';
import type { WawiSalesOverviewView } from '../models/WawiSalesOverviewView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WawiService {
    /**
     * Get Wawi pending orders
     * Get pending orders from user Wawi database grouped by shipping type
     * @returns WawiOrdersView Pending orders grouped by shipping type
     * @throws ApiError
     */
    public static getAppWawiOrders(): CancelablePromise<WawiOrdersView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/wawi/orders',
            errors: {
                400: `Error`,
                403: `Plan does not include Lieferbar / pending orders (e.g. Free mobile)`,
            },
        });
    }
    /**
     * Wawi sales overview (revenue and orders by day)
     * Aggregates orders from the user's JTL-Wawi database (data source): daily gross revenue from positions and order counts, period totals, and percent change vs the previous period of the same length. Default range is the last 30 calendar days (inclusive).
     * @param startDate Period start (Y-m-d). Must be used together with endDate.
     * @param endDate Period end (Y-m-d). Must be used together with startDate.
     * @returns WawiSalesOverviewView Sales overview
     * @throws ApiError
     */
    public static getAppWawiSalesOverview(
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<WawiSalesOverviewView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/wawi/statistics/sales-overview',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Error`,
                403: `Plan does not include the analytics Dashboard (e.g. Free mobile)`,
            },
        });
    }
}
